// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3qA6F","rootSmall":"AddTileButton_rootSmall__3sCMY"};